/*eslint-disable*/
class GoogleTag {
    constructor(trackingId) {
        this.trackingId = trackingId;
        this._init();
    }

    gtag() {
        window.dataLayer.push(arguments);
    }

    _init() {
        window.dataLayer = window.dataLayer || [];
        this.gtag('js', new Date());
        this.config();
    }

    config(parameters) {
        let functionParameters = ['config', this.trackingId]
        if (parameters) {
            functionParameters.push(parameters)
        }
        this.gtag(...functionParameters);
    }

    sendPage(to) {
      this.config({'page_path': to.fullPath});
    }
}

export default GoogleTag;
